import type { AnyAction, Reducer, CombinedState } from '@reduxjs/toolkit';

export const mergeReducer =
  <
    R1 extends Reducer,
    R2 extends Reducer,
    MS extends ReturnType<R1> & ReturnType<R2>,
  >(
    reducer1: R1,
    reducer2: R2
  ): Reducer<CombinedState<MS>> =>
  (state: MS | undefined, action: AnyAction) => {
    return reducer2(reducer1(state, action), action);
  };
